import React from "react";
import { connect } from "react-redux";
import { Button, Modal } from "semantic-ui-react";
import ConfirmModalAction from "@common/redux/actions/ConfirmModalAction";

const ConfirmModal = (props) => {
  const closeModal = () => {
    ConfirmModalAction.reset().then(ConfirmModalAction.onClose);
  };

  const confirm = () => {
    ConfirmModalAction.reset().then(ConfirmModalAction.onConfirm);
  };

  return (
    <Modal
      open={props.data.open}
      onClose={closeModal}
      size="tiny"
      centered={false}
      style={{ zIndex: "90000000000" }}
    >
      <Modal.Header>{props.data.title}</Modal.Header>
      <Modal.Content content={props.data.message} />
      <Modal.Actions>
        <Button onClick={closeModal} color="red">
          Cancel
        </Button>
        <Button onClick={confirm} color="green">
          {props.data.okLabel ?? "Ok"}
        </Button>
      </Modal.Actions>
    </Modal>
  );
};

const mapStateToProps = (state) => {
  return {
    data: ConfirmModalAction.getStatePath(state),
  };
};

export default connect(mapStateToProps)(ConfirmModal);
